// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as $ from 'jquery';
// Service Class
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { PrePayService } from './../../../../services/common/pre-pay.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { PrepayFilter } from './../../../../models/PrepayFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { Subscription } from 'rxjs';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-prepay-contract',
  templateUrl: './prepay-contract.component.html',
  styleUrls: ['./prepay-contract.component.scss']
})
export class PrepayContractComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  contractId: string;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  datemodel: NgbDateStruct;
  dateFilterTo: any;
  dateFilterFrom: any;
  fromDate: any;
  toDate: any;
  fromDateFilter: any;
  toDateFilter: any;
  transactionsList: any = [];
  transactionsListingData: any = [];
  transaction: any = {};
  filter: PrepayFilter = new PrepayFilter();
  beforeMenu: any;
  showExport = true;
  businessLine: string;
  accountNo: number;
  userReserved: string;
  activeCropYear: any;
  contractData: any;
  filterStartDate: any;
  filterEndDate: any;

  @ViewChild('contractsTable', { read: MatSort }) contractsSort: MatSort;
  @ViewChild('contractsPaginator', { read: MatPaginator }) contractsPaginator: MatPaginator;
  contractsColumns: string[] = ['transactionDate', 'transaction', 'contractNo', 'description', 'transactionAmount', 'previousBalance', 'currentBalance'];
  contractsFooterColumns: string[] = ['transactionDate', 'transaction', 'contractNo', 'description', 'transactionAmount', 'previousBalance', 'currentBalance'];
  public contractsDataSource: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private excelService: ExcelService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private prePayService: PrePayService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.contractData = this.prePayService.getPrePayContractData();
    // Get Active CropYear
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.contractData) {
      this.contractId = this.contractData.contractId;
      this.prePayService.selectedAccount = this.contractData.accountNo;

      this.getCropYearData();
    } else {
      this.navigateToPrePay(); // when user has migrated directly to this page through url
    }
  }

  // Added ngAfterViewInit to calculate height of contract table
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // set account table height
  setAccountTableHeight() {
    const tableHeight = window.innerHeight - $('.prepayContractTop').outerHeight() - $('.prepayDateFilter').outerHeight() - $('.prepayContractPaging').outerHeight() - 172;
    $('.prepayContractTable').css('max-height', tableHeight + 'px');
  }

  // Get Crop Year data
  getCropYearData() {
    this.subscription.push(this.prePayService.getCropYearData().subscribe((results: any) => {
      const cropData = results.filter(t => t.cropYear === +this.contractData.cropYear);

      if (cropData.length > 0) {
        this.fromDate = cropData[0].startDate;
        this.toDate = cropData[0].endDate;
      } else {
        this.fromDate = this.activeCropYear.startDate;
        this.toDate = this.activeCropYear.endDate;
      }
      this.filterStartDate = new Date((+this.contractData.cropYear - 2), 6, 1, 23, 59, 59);
      this.filterEndDate = new Date((+this.contractData.cropYear + 2), 5, 30, 23, 59, 59);
      this.dateFilterLimit();
      this.getContractDetails();
    }, error => {
      this.fromDate = this.activeCropYear.startDate;
      this.toDate = this.activeCropYear.endDate;
    }));
  }

  // Get Contract Details Data
  getContractDetails() {
    this.loaderService.setLoaderStatus(true);
    const data = {
      contractId: this.contractData.contractId,
      fromDate: null,
      toDate: null,
      businessLine: this.contractData.businessLine,
      accountNo: this.contractData.accountNo,
      userReserved: this.contractData.userReserved
    };

    if (this.fromDate !== undefined) {
      data.fromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    } else {
      data.fromDate = new Date(this.fromDate);
    }
    if (this.toDate !== undefined) {
      data.toDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    } else {
      data.toDate = new Date(this.toDate);
    }

    this.subscription.push(this.prePayService.getContractsDetailsData(data).subscribe((results: any) => {
      if (results) {
        this.transaction = results;
        this.transactionsListingData = this.transaction.transactionsList;
        if (this.transaction.transactionsList.length === 0) {
          this.contractsFooterColumns = [];
          this.showExport = false;
        } else {
          this.contractsFooterColumns = ['transactionDate', 'transaction', 'contractNo', 'description', 'transactionAmount', 'previousBalance', 'currentBalance'];
          this.showExport = true;
        }
        this.contractsDataSource = new MatTableDataSource(this.transactionsListingData);
        this.contractsDataSource.sort = this.contractsSort;
        this.contractsDataSource.paginator = this.contractsPaginator;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Go back to Prepay landing page
  navigateToPrePay() {
    this.router.navigate(['/prepay']);
  }

  // Set the date filter limit for date pickers
  dateFilterLimit() {
    const minDate = this.filterStartDate;
    const maxDate = this.filterEndDate;

    this.fromDateFilter = (d: Date): boolean => {
      const calendarDate = d;
      return calendarDate >= minDate && calendarDate <= maxDate;
    };

    this.toDateFilter = (d: Date): boolean => {
      const calendarDate = d;
      return calendarDate >= minDate && calendarDate <= maxDate;
    };
  }

  // Validate selected date on date picker
  validateDateFilter(contextFrom, $event) {
    const minDate = new Date(this.filterStartDate);
    const maxDate = new Date(this.filterEndDate);

    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.toDate) {
        var toDate = new Date(this.toDate);
        this.fromDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= minDate && calendarDate <= maxDate && calendarDate <= toDate;
        };
      }
      this.toDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= minDate && calendarDate <= maxDate && calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.fromDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= minDate && calendarDate <= maxDate && calendarDate <= toDate;
      };
      if (this.fromDate) {
        var fromDate = new Date(this.fromDate);
        this.toDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= minDate && calendarDate <= maxDate && calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromDateFilter = '';
      this.toDateFilter = '';
    }

    if (this.fromDate !== undefined && this.toDate !== undefined) {
      this.getContractDetails();
    }
  }
  // return count of total transactions
  getTotalTransactions() {
    return this.transactionsListingData.length;
  }

  // Function to add 2 decimal places to number and comma formatting
  numberWithCommas(x) {
    const parts = parseFloat(x).toFixed(2).toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  // Generate excel report
  exportData() {
    const exportData = [];
    if (this.transaction.transactionsList && this.transaction.transactionsList.length > 0) {
      this.transaction.transactionsList.forEach(x => {
        // Don't export SubTotal rows
        exportData.push({
          'Transaction Date': this.datePipe.transform(x.transactionDate, 'MM-dd-yyyy'),
          'Transaction #': x.transaction,
          'Contract Number': x.contractNo,
          'Description': x.description,
          'Transaction Amount($)': { v: x.transactionAmount, t: 'n', z: '#,##0.00', alignRight: true },
          'Previous($)': { v: x.previousBalance, t: 'n', z: '#,##0.00', alignRight: true },
          'Current($)': { v: x.currentBalance, t: 'n', z: '#,##0.00', alignRight: true }
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'TransactionDetails');

      this.loaderService.setLoaderStatus(false);
    }
  }

  // Generate pdf report
  generatePdf() {
    if (this.transaction.transactionsList && this.transaction.transactionsList.length > 0) {
      const documentDefinition = this.getDocumentDefinition();
      pdfMake.createPdf(documentDefinition).download('TransactionDetails.pdf');
    }
  }

  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM-dd-yyyy');
    const supplier = this.transaction.transactionsList[0].supplier;
    const fromPdfDate = this.fromDate === undefined ? this.datePipe.transform(this.transaction.transactionsList[0].transactionDate, 'MM-dd-yyyy') + ' to ' : this.datePipe.transform(this.fromDate, 'MM-dd-yyyy') + ' to ';
    const toPdfDate = this.toDate === undefined ? currDate : this.datePipe.transform(this.toDate, 'MM-dd-yyyy');

    return {
      footer: function (currentPage, pageCount, pageSize) {
        return [

          {
            text: currDate, alignment: 'left', fontSize: 8, marginLeft: 45
          },
          {
            text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', fontSize: 8, marginRight: 45
          },
        ];
      },
      content: [
        {
          text: 'Prepay Statement',
          bold: true,
          fontSize: 16,
          alignment: 'left',
          margin: [0, 0, 0, 20]
        },
        {
          image: 'data:image/png;base64,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',
          width: 120,
          height: 40,
          alignment: 'right',
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['Supplier :', supplier],
              ['Selected Account Numbers :', this.transaction.accountNo],
              ['Account Name :', this.transaction.account],
              ['Selected Transaction Date Range:', fromPdfDate + toPdfDate]
            ]
          },
          fontSize: 10,
          marginTop: 10
        },

        this.getContractPdfObject(this.transaction.transactionsList),

      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#EBF1DE',
          fontSize: 7,
        },
        tablefont: {
          fontSize: 8,
          marginTop: 10
        }
      }
    };
  }

  getContractPdfObject(prepayDetails: any) {
    return {
      table: {
        widths: ['14%', '11%', '10%', '22%', '15%', '14%', '14%'],
        body: [
          [{
            text: 'Transaction Date',
            style: 'tableHeader'
          },
          {
            text: 'Transaction #',
            style: 'tableHeader'
          },
          {
            text: 'Contract Number',
            style: 'tableHeader'
          },
          {
            text: 'Description',
            style: 'tableHeader'
          },
          {
            text: 'Transaction Amount($)',
            style: 'tableHeader'
          },
          {
            text: 'Previous($)',
            style: 'tableHeader'
          },
          {
            text: 'Current($)',
            style: 'tableHeader'
          },
          ],
          ...prepayDetails.map(pd => [this.datePipe.transform(pd.transactionDate, 'MM-dd-yyyy'), pd.transaction, pd.contractNo, pd.description, { text: this.numberWithCommas(pd.transactionAmount), alignment: 'right' }, { text: this.numberWithCommas(pd.previousBalance), alignment: 'right' }, { text: this.numberWithCommas(pd.currentBalance), alignment: 'right' }])
        ]
      },
      style: 'tablefont',
    };
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());

    this.prePayService.setPrepayContractData(undefined);
  }
}
